<template>
  <div class="lead-form-modal">
    <div class="lead-form-modal__underlay"></div>
    <div class="lead-form-modal__inner px-4">
      <form
        class="lead-form-modal__form text-left bg-white shadow-md rounded px-8 pt-6 pb-8 my-12"
        ref="form"
        @submit.prevent="submitForm"
      >
        <div class="mb-6">
          <div class="text-black">
            Thank you for your interest in {{ brandName }}.<br />Please complete
            your details below to review your favourites.
          </div>
        </div>
        <input type="hidden" name="leadSource" :value="leadSource" />
        <template v-for="field in fields">
          <input
            v-if="field.type === 'hidden'"
            :key="field.name"
            :name="field.name"
            type="hidden"
            :value="field.value"
          />
          <div
            v-if="
              field.type === 'text' ||
                field.type === 'tel' ||
                field.type === 'email'
            "
            class="mb-6"
            :key="field.name"
          >
            <label
              v-if="field.label"
              class="block text-gray-700 text-sm font-bold mb-2"
              :for="field.name"
              v-html="field.label"
            ></label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              :id="field.name"
              :name="field.name"
              :required="field.required"
              :type="field.type"
              :value="field.value"
            />
          </div>
          <div v-if="field.type === 'select'" class="mb-6" :key="field.name">
            <label
              v-if="field.label"
              class="block text-gray-700 text-sm font-bold mb-2"
              :for="field.name"
              v-html="field.label"
            ></label>
            <select
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              :id="field.name"
              :name="field.name"
              :required="field.required"
            >
              <option
                v-for="option in field.options"
                :key="option.value"
                :value="option.value"
                :disabled="option.disabled"
                :selected="option.selected"
                >{{ option.label }}</option
              >
            </select>
          </div>
          <div v-if="field.type === 'checkbox'" class="mb-6" :key="field.name">
            <label class="block text-gray-700 font-bold flex">
              <input
                class="mr-2 leading-tight"
                type="checkbox"
                :required="field.required"
                :name="field.name"
              />
              <span
                class="text-sm"
                v-html="parseFieldLabel(field.label)"
              ></span>
            </label>
          </div>
        </template>
        <div class="text-left">
          <button
            :disabled="isSubmitting || isSubmitted"
            class="button"
            type="submit"
          >
            {{
              isSubmitted
                ? "Thank you"
                : isSubmitting
                ? "Submitting..."
                : "Submit"
            }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
const formTemplate = process.env.VUE_APP_FORM_TEMPLATE;
const fields = require(`../form-templates/fields.${formTemplate}.js`);
import axios from "axios";
export default {
  data() {
    return {
      brandName: this.$config.brandName,
      leadSource: "",
      email: "",
      fields: fields,
      isSubmitted: false,
      isSubmitting: false,
    };
  },

  mounted() {
    document.body.style.overflow = "hidden";
    const email = new URL(location.href).searchParams.get("e");
    if (email?.length) {
      this.email = email;
    }

    // If the URL has a 'ref' parameter then the user came from the email send by the favourites tool - otherwise they came from the qr favourites
    const ref = new URL(location.href).searchParams.get("ref");
    this.leadSource =
      ref?.length && ref === "tool"
        ? "Favourites Tool"
        : "Touchscreen QR Favourites";
  },

  methods: {
    createReturningCookie() {
      let expiry = new Date(Date.now() + 1000 * 60 * 60 * 24 * 30); // 30 Days
      expiry = expiry.toUTCString();
      document.cookie = "r=1;samesite=strict;expires=" + expiry;
    },

    getFormData(form) {
      const formDataArray = new FormData(form);
      let formData = {};

      Array.from(formDataArray.entries()).forEach((field) => {
        let [key, value] = field;
        if (value === "on") {
          value = true;
        }
        formData[key] = value;
      });

      formData.interestedPropertyMetas = this.$store.getters.favouriteProperties.map(
        (property) => property.meta
      );
      formData.interestedPropertyIds = this.$store.getters.favouritePropertyIds;
      formData.interestedPropertyLabels = this.$store.getters.favouritePropertyLabels.toString();

      return formData;
    },

    parseFieldLabel(label) {
      if (label.includes("{{privacyLink}}")) {
        label = label.replaceAll("{{privacyLink}}", this.$config.links.privacy);
      }
      return label;
    },

    submitForm() {
      this.isSubmitting = true;
      axios
        .post(
          this.$store.state.API_HOST + "/favourites/lead",
          this.getFormData(this.$refs.form)
        )
        .then(() => {})
        .finally(() => {
          this.createReturningCookie();
          this.isSubmitting = false;
          this.isSubmitted = true;
          setTimeout(() => {
            this.$emit("submitted");
            document.body.style.overflow = "initial";
          }, 1000);
        });
    },
  },
};
</script>

<style lang="scss">
.lead-form-modal {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  &__inner {
    max-height: 100vh;
    overflow: scroll;
    pointer-events: auto;
    z-index: 10;
  }

  &__close {
    background-color: rgba(#333, 0.8);
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;

    svg {
      height: 40px;
      width: 40px;
    }
  }

  &__underlay {
    background: rgba(0, 0, 0, 0.8);
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  &__form {
    position: relative;
  }
}
</style>
